import React from 'react';

import {useAxios} from '../../../hooks/use-axios';

const useVendas = () => {

    const {getApiEmitirNotas} = useAxios();

    const getVendaOuPedido = async (id, tipo) => {
        const api = await getApiEmitirNotas();
        const result = await api.get(normalizaTipo(tipo) + '/' + id);
        return result.data;
    }   

    const normalizaTipo = (tipo) => {
        switch(tipo){
            case 'Pedido':
                return 'pedidos';
            default:
                return 'vendas';
        }
    }

    return {getVendaOuPedido};


}

export {useVendas};